import React, { Component } from "react";
import CSVSVGReceive from "../../../Assets/svg/CSVSVGRecieve.svg";
import CSVReceiveMethodPopUp from "./CSVRecieveMethodPopUp";
import CSVSentToMail from "./CSVSentToMail";
import CSVProcessingOnSite from "./CSVProcessingOnSite";
import CSVProcessingOnSiteFailed from "./CSVProcessingOnSiteFailed";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FetchIndividualFileAction, ResetAnalysisReduxStateAction } from "../../../Actions/Analysis";

class PopUp extends Component {
  static propTypes = {
    csvAnalysisSuccess: PropTypes.bool,
    SendToMail: PropTypes.func.isRequired,
    RenderOnSite: PropTypes.func.isRequired,
    isSentToMail: PropTypes.bool,
    isRenderOnSite: PropTypes.bool,
    navigate: PropTypes.func.isRequired,
    csvAnalysisSuccessMessage: PropTypes.string,
    FetchIndividualFileAction: PropTypes.func.isRequired,
    AddedFileID: PropTypes.string,
    pdfAnalysisSuccess: PropTypes.bool,
    currentUser: PropTypes.object,
  };

  state = {
    progress: 0,
    progressStage: "",
  };

  _ws = null;
  _pingInterval = null;

  componentDidMount() {
    this._connectWebSocket();
  }

  componentWillUnmount() {
    this._disconnectWebSocket();
  }

  _connectWebSocket = () => {
    const userId = this.props.currentUser?.id;
    if (!userId) return;

    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    const host = window.location.host;
    const url = `${protocol}://${host}/ws/file-ingest/${userId}/`;

    console.log("[SurveyProgress] Connecting WebSocket:", url);
    const ws = new WebSocket(url);
    this._ws = ws;

    ws.onopen = () => {
      console.log("[SurveyProgress] WebSocket connected");
      // Keep alive with ping every 30s
      this._pingInterval = setInterval(() => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({ type: "ping" }));
        }
      }, 30000);
    };

    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        console.log("[SurveyProgress] Event:", data);

        // Only handle survey_analysis events for the current file
        if (data.event_type && data.event_type !== "survey_analysis") return;
        const currentFileId = parseInt(this.props.AddedFileID, 10);
        if (data.file_id && data.file_id !== currentFileId) {
          console.log("[SurveyProgress] Ignoring event for different file:", data.file_id, "vs", currentFileId);
          return;
        }

        this.setState({
          progress: data.progress != null ? data.progress : this.state.progress,
          progressStage: data.stage || this.state.progressStage,
        });

        if (data.status === "COMPLETED") {
          if (this.props.AddedFileID) {
            this.props.FetchIndividualFileAction(this.props.AddedFileID);
            this.props.navigate(`result-summary/${this.props.AddedFileID}`);
          }
          this._disconnectWebSocket();
        }

        if (data.status === "FAILED") {
          this.setState({
            progress: 0,
            progressStage: data.error || "Analysis failed",
          });
        }
      } catch {
        // ignore
      }
    };

    ws.onclose = (e) => {
      console.log("[SurveyProgress] WebSocket closed:", e.code);
      // Reconnect if not intentionally closed and still processing
      if (this._ws && !this.props.csvAnalysisSuccess) {
        console.log("[SurveyProgress] Reconnecting in 3s...");
        setTimeout(() => this._connectWebSocket(), 3000);
      }
    };

    ws.onerror = (e) => {
      console.error("[SurveyProgress] WebSocket error:", e);
    };
  };

  _disconnectWebSocket = () => {
    if (this._pingInterval) {
      clearInterval(this._pingInterval);
      this._pingInterval = null;
    }
    const ws = this._ws;
    this._ws = null;
    if (ws) {
      ws.close();
    }
  };

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.csvAnalysisSuccess &&
        this.props.csvAnalysisSuccess &&
        this.props.isRenderOnSite) ||
      (!prevProps.pdfAnalysisSuccess &&
        this.props.pdfAnalysisSuccess &&
        this.props.isRenderOnSite)
    ) {
      this.props.navigate(`result-summary/${this.props.AddedFileID}`);
    }
  }

  render() {
    return (
      <div className="fixed w-full h-screen inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50">
        {!this.props.csvFileUploadSuccess &&
          !(this.props.isSentToMail || this.props.isRenderOnSite) && (
            <CSVReceiveMethodPopUp />
          )}
        {this.props.isSentToMail && <CSVSentToMail />}
        {this.props.isRenderOnSite && !this.props.csvAnalysisSuccess && (
          <CSVProcessingOnSite
            onCancel={() => {
              this._disconnectWebSocket();
              this.props.ResetAnalysisReduxStateAction();
              this.props.navigate("/dashboard");
            }}
            progress={this.state.progress}
            progressStage={this.state.progressStage}
          />
        )}
        {this.props.isRenderOnSite &&
          !this.props.csvAnalysisSuccess &&
          this.props.csvAnalysisSuccessMessage && <CSVProcessingOnSiteFailed />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  csvAnalysisSuccess: state.analysis.csvAnalysisSuccess,
  isSentToMail: state.analysis.isSentToMail,
  isRenderOnSite: state.analysis.isRenderOnSite,
  csvAnalysisSuccessMessage: state.analysis.csvAnalysisSuccessMessage,
  AddedFileID: state.analysis.AddedFileID,
  pdfAnalysisSuccess: state.analysis.pdfAnalysisSuccess,
  currentUser: state.authentication?.user,
});

export default withRouterHooks(
  connect(mapStateToProps, { FetchIndividualFileAction, ResetAnalysisReduxStateAction })(PopUp)
);
